import { render, staticRenderFns } from "./MoveableElement.vue?vue&type=template&id=283bc8b6&scoped=true&"
import script from "./MoveableElement.vue?vue&type=script&lang=ts&"
export * from "./MoveableElement.vue?vue&type=script&lang=ts&"
import style0 from "./MoveableElement.vue?vue&type=style&index=0&id=283bc8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bc8b6",
  null
  
)

export default component.exports